// extracted by mini-css-extract-plugin
export default {"list":"Gfqh8gmy964qALS4IrHE","item":"xLJT44p0ESedjTokk2tz","buyBtn":"KbzBDUETKxfr3Os3pbPg","summary":"QgnDrcPDqFxLIWPVMXTR"};